// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
// import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowDown'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	Box,
	Collapse,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	withStyles,
} from '@mui/material'
import React, { useState } from 'react'

import { darkenRgbaCssColor } from '@/utils/color'

type SubRowType = {
	name: string
	value: number
	benchmark: number
	signification: number
}

type RowData = {
	questionIndex: number
	question: string
	benchmark: string
	data: SubRowType[]
}

type Props = {
	data: RowData[]
	changeUrl: string
	translations: Map<string, string>
	fontColor: string | null
	rowColor: string | null
	rowContentColor: string | null
}

export const VoeSignificationTable = (props: Props) => {
	const [openRow, setOpenRow] = useState<number | null>(null)

	const StyledTableCell = withStyles({
		root: {
			...(props.fontColor !== null ? { color: props.fontColor } : {}),
		},
	})(TableCell)

	const Row = (rowProps: { rowData: RowData; open: boolean; openCallback: (open: boolean) => void }) => (
		<React.Fragment>
			<TableRow
				style={{
					background: props.rowColor ?? 'rgb(218, 227, 243)',
					borderBottom: `solid 2px ${darkenRgbaCssColor(props.rowColor ?? 'rgb(68, 116, 194)', 0.8)}`,
					...(rowProps.open ? { position: 'sticky', top: 0 } : {}),
				}}
			>
				<StyledTableCell style={{ width: '60px' }}>
					<IconButton aria-label="expand row" size="small" onClick={() => rowProps.openCallback(!rowProps.open)}>
						{rowProps.open ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}
					</IconButton>
				</StyledTableCell>
				<StyledTableCell>{rowProps.rowData.question}</StyledTableCell>
				<StyledTableCell style={{ width: '100px' }}>
					{props.translations.get('core.action_planner.table.headers.result')}
				</StyledTableCell>
				<StyledTableCell style={{ width: '100px' }}>{rowProps.rowData.benchmark}</StyledTableCell>
			</TableRow>
			<TableRow
				style={{
					background: props.rowContentColor ?? 'transparent',
					...(rowProps.open ? {} : { display: 'none' }),
				}}
			>
				<StyledTableCell style={{ paddingLeft: 0, paddingRight: 0 }} colSpan={5}>
					<Collapse in={rowProps.open} timeout={'auto'} unmountOnExit>
						<Box>
							<Table>
								<TableBody>
									{rowProps.rowData.data.map((subRow) => (
										<TableRow
											style={{
												borderBottom: `solid 2px ${
													props.rowContentColor !== null
														? darkenRgbaCssColor(props.rowContentColor, 0.8)
														: 'transparent'
												}`,
												borderTop: `solid 2px ${
													props.rowContentColor !== null
														? darkenRgbaCssColor(props.rowContentColor, 0.8)
														: 'transparent'
												}`,
											}}
										>
											<StyledTableCell style={{ width: '60px' }}></StyledTableCell>
											<StyledTableCell>{subRow.name}</StyledTableCell>
											<StyledTableCell
												style={{
													width: '100px',
													...(subRow.signification !== 0 ? { color: subRow.signification > 0 ? 'green' : 'red' } : {}),
												}}
											>
												{subRow.value}
											</StyledTableCell>
											<StyledTableCell style={{ width: '100px' }}>{subRow.benchmark}</StyledTableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</StyledTableCell>
			</TableRow>
		</React.Fragment>
	)

	const handleSectionOpen = (sectionIndex: number | null) => {
		setOpenRow(sectionIndex)

		$.nette.ajax({
			url: props.changeUrl,
			data: {
				questionIndex: sectionIndex !== null ? (props.data[sectionIndex]?.questionIndex ?? -1) : -1,
			},
		})
	}

	return (
		<TableContainer component={Paper} style={{ height: '100%' }}>
			<Table aria-label="collapsible table">
				<TableBody>
					{props.data.map((entry, index) => (
						<Row
							key={index}
							rowData={entry}
							open={openRow === index}
							openCallback={(isOpen: boolean) => handleSectionOpen(isOpen ? index : null)}
						/>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
